import addClasses from '../../../utils/addClasses';
import { addEvent } from '../../../utils/events';
import createAnchorInlineElement from './createElements/createAnchorInlineElement';
import createTextInlineElement from './createElements/createTextInlineElement';

export default function formatInlineEdit(element) {
  for (const inlineEdit of element) {
    /* CREATE INLINE EDIT FOR TEXT */

    if (!inlineEdit.classList.contains('format-done') && inlineEdit.tagName !== 'A') {
      createTextInlineElement(inlineEdit);
      const span = inlineEdit.querySelector('span');
      const input = inlineEdit.querySelector('input');
      if (inlineEdit.classList.contains('text--center')) {
        addClasses(span, [
          'inline-edit',
          'inline-edit--align-left',
          'form-fields',
        ]);
        input.classList.add('text--center');
      } else if (inlineEdit.classList.contains('text--left')) {
        addClasses(span, [
          'inline-edit',
          'inline-edit--align-left',
          'form-fields',
        ]);
        input.classList.add('text--left');
      } else if (inlineEdit.classList.contains('text--right')) {
        addClasses(span, [
          'inline-edit',
          'inline-edit--align-right',
          'form-fields',
        ]);
        input.classList.add('text--right');
      } else {
        addClasses(span, [
          'inline-edit',
          'inline-edit--align-left',
          'form-fields',
        ]);
        input.classList.add('text--left');
      }
      if (inlineEdit.classList.contains('required')) {
        input.classList.add('required');
      }
    }

    /* CREATE INLINE EDIT FOR ANCHOR LINKS */

    if (inlineEdit.tagName === 'A') {
      let linkConfig = {};

      const linkParent = inlineEdit.parentElement;
      linkParent.classList.add('inline--edit-link');
      linkParent.classList.add('inline--edit');

      // create edit icon
      const spanIcon = document.createElement('div');
      spanIcon.classList.add('inline--edit-icon');
      const icon = document.createElement('i');
      icon.classList.add('icon-cme-pencil');
      const iconDisabled = document.createElement('i');
      iconDisabled.classList.add('icon-cme-pencil');
      iconDisabled.classList.add('display--none');
      spanIcon.appendChild(icon);
      spanIcon.appendChild(iconDisabled);

      // reorg anchor element
      const spanAnchor = document.createElement('div');
      spanAnchor.classList.add('inline--edit-anchor');
      const anchor = inlineEdit;
      spanAnchor.appendChild(anchor);

      // Append edit icon to parent
      linkParent.appendChild(spanAnchor);
      linkParent.appendChild(spanIcon);

      // Add event listener for icon onclick
      addEvent(icon, 'click', () => {
        icon.classList.add('display--none');
        iconDisabled.classList.remove('display--none');
        // Removes anchor element
        linkConfig = createAnchorInlineElement(spanAnchor);
        linkConfig.icons = {
          icon,
          iconDisabled,
        };

        // Create input element for inline edit
        createTextInlineElement(spanAnchor, linkParent, linkConfig);

        // Add required classes to span and input elements
        const span = spanAnchor.querySelector('span');
        const input = spanAnchor.querySelector('input');
        if (linkParent.classList.contains('text--center')) {
          addClasses(span, [
            'inline-edit',
            'inline-edit--align-left',
            'form-fields',
          ]);
          input.classList.add('text--center');
        } else if (linkParent.classList.contains('text--left')) {
          addClasses(span, [
            'inline-edit',
            'inline-edit--align-left',
            'form-fields',
          ]);
          input.classList.add('text--left');
        } else if (linkParent.classList.contains('text--right')) {
          addClasses(span, [
            'inline-edit',
            'inline-edit--align-right',
            'form-fields',
          ]);
          input.classList.add('text--right');
        } else {
          addClasses(span, [
            'inline-edit',
            'inline-edit--align-left',
            'form-fields',
          ]);
          input.classList.add('text--left');
        }

        input.focus();
        input.select();
      });
    }
  }

  return element;
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/formatInlineEdit.js